import React from 'react';
import { ScreenVoteDecision } from '../../StudyList';
import { Button } from 'components/core';
import { AsyncVoteFunction } from 'hooks/study/useMakeVote';

type ResolveVoteButtonProps = {
  vote: ScreenVoteDecision;
  doVote: AsyncVoteFunction;
  isVoting: boolean;
};
const ResolveVoteButton = ({
  vote,
  doVote,
  isVoting,
}: ResolveVoteButtonProps) => {
  return (
    <Button
      disabled={isVoting}
      type="brand"
      size="sm"
      onClick={() => doVote(vote, true)}
      data-pendo-key="vote-button"
    >
      {vote}
    </Button>
  );
};

export default ResolveVoteButton;
